'use client';

import type { CSSProperties, ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { DialogSurfaceThemeProvider } from '../ui/dialog-surface-theme';
import { AuthPublicLayout } from './AuthPublicLayout';

/** Login and reset-password use the same full-focus shell (no global nav/footer). */
function isBareAuthShell(pathname: string | null): boolean {
  if (!pathname) return false;
  return (
    pathname.startsWith('/admin/login') ||
    pathname.startsWith('/admin/reset-password')
  );
}

export function AuthPublicLayoutRouter({
  children,
}: {
  children: ReactNode;
}) {
  const pathname = usePathname();

  if (isBareAuthShell(pathname)) {
    return (
      <div
        className='flex min-h-screen flex-col bg-background text-foreground'
        data-app-theme='auth-login'
        style={
          {
            '--theme-background': '#ffffff',
            '--color-background': '#ffffff',
          } as CSSProperties
        }
      >
        <DialogSurfaceThemeProvider value='auth-login'>
          <main className='flex min-h-screen flex-1 flex-col'>{children}</main>
        </DialogSurfaceThemeProvider>
      </div>
    );
  }

  return <AuthPublicLayout>{children}</AuthPublicLayout>;
}
